"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Divider element used in billings
 * @returns {JSX.Element}
 */
function Divider() {
    return react_1.default.createElement("div", { className: 'storybook-billings-divider my-sm' });
}
exports.Divider = Divider;
